export default __webpack_public_path__ + "static/media/mobileAppIcon-removebg-preview.8cce3cea.png";